import { render, staticRenderFns } from "./VideoTile.vue?vue&type=template&id=4472c732&scoped=true&"
import script from "./VideoTile.vue?vue&type=script&lang=ts&"
export * from "./VideoTile.vue?vue&type=script&lang=ts&"
import style0 from "./VideoTile.vue?vue&type=style&index=0&id=4472c732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4472c732",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
